import { NgIf } from '@angular/common';
import { Component, Input, TemplateRef } from '@angular/core';

@Component({
  selector: 'lib-andromeda-custom-tooltip',
  templateUrl: './andromeda-custom-tooltip.component.html',
  styleUrls: ['./andromeda-custom-tooltip.component.scss'],
  imports: [NgIf],
})
export class AndromedaCustomTooltipComponent {
  @Input() text: string;
  @Input() content: TemplateRef<any>;
  @Input() marginLeft: string;
}
